'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { noTooltipInternal } from '../icon-button/icon-button-internal.utils.js';
import { useSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { IconButton } from '../icon-button/icon-button.component.js';
import { Icon } from '../icon/icon.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const AdaptiveCarouselSlideNavigationInternal = renderWithRef('AdaptiveCarouselSlideNavigationInternal', null, (o, c)=>{
    let { carouselId: l, setPreviousSlide: p, setNextSlide: u, isPreviousDisabled: b, isNextDisabled: d, skin: f = 'standard' } = o, v = _object_without_properties(o, [
        "carouselId",
        "setPreviousSlide",
        "setNextSlide",
        "isPreviousDisabled",
        "isNextDisabled",
        "skin"
    ]), { t: y } = useSwanI18nContext(), _ = new Set([
        'swan-adaptive-carousel-slide-navigation-internal'
    ]), j = {
        'aria-controls': l,
        skin: 'promo-bar' === f ? 'tertiary' : void 0,
        tooltip: ''
    };
    return jsxs(RenderComp, {
        root: "div",
        forwardedRef: c,
        classNames: _,
        props: v,
        children: [
            jsx(IconButton, _object_spread_props(_object_spread({
                className: b ? 'swan-adaptive-carousel-slide-navigation-internal-disabled' : '',
                "aria-disabled": b ? 'true' : void 0,
                onClick: b ? void 0 : p,
                "aria-label": y('adaptive-carousel-slide-navigation-internal.accessible-text-for-previous-button')
            }, j, noTooltipInternal), {
                children: jsx(Icon, {
                    iconType: "chevronLeft"
                })
            })),
            jsx(IconButton, _object_spread_props(_object_spread({
                className: d ? 'swan-adaptive-carousel-slide-navigation-internal-disabled' : '',
                "aria-disabled": d ? 'true' : void 0,
                onClick: d ? void 0 : u,
                "aria-label": y('adaptive-carousel-slide-navigation-internal.accessible-text-for-next-button')
            }, j, noTooltipInternal), {
                children: jsx(Icon, {
                    iconType: "chevronRight"
                })
            }))
        ]
    });
});

export { AdaptiveCarouselSlideNavigationInternal };
